import { GlobalStyle } from '@components/GlobalStyle';
import { HideOnNotification } from '@components/HideOnNotification';
import { Shell } from '@containers/Shell';
import MomentUtils from '@date-io/moment';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { RegisterNotificationEngine } from '@packages/notifications';
import { MATERIAL_UI_THEME, THEME_CONFIG } from '@packages/style/themes/default';
import { history, store } from '@redux-src/store';
import { checkLogin } from '@redux/Auth/actions';
import { wholesalerSubdomainGetRequest } from '@redux/Wholesaler/actions';
import { SnackbarProvider, SnackbarProviderProps } from 'notistack';
import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { Router } from 'react-router';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

store.dispatch(checkLogin());
store.dispatch(wholesalerSubdomainGetRequest());
const snackbarProps: Omit<SnackbarProviderProps, 'children'> = {
    autoHideDuration: 3000,
    maxSnack: 3,

    anchorOrigin: {
        horizontal: 'right',
        vertical: 'bottom',
    },

    classes: {
        root: 'notify__element-root',
        containerAnchorOriginBottomRight: 'notify__container',
    },
};

/**
 *
 * @author: Dumitrana Alinus <alinus@wooter.co>
 * @component: App
 * @date: 26.02.2021
 * @time: 04:52
 */
export function App() {
    return (
        <SnackbarProvider {...snackbarProps}>
            <>
                <HideOnNotification />
                <RegisterNotificationEngine />
                <MuiThemeProvider theme={MATERIAL_UI_THEME}>
                    <StyledThemeProvider theme={THEME_CONFIG}>
                        <>
                            <GlobalStyle />
                            <ReduxProvider store={store}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <Router history={history as any}>
                                        <Shell />
                                    </Router>
                                </MuiPickersUtilsProvider>
                            </ReduxProvider>
                        </>
                    </StyledThemeProvider>
                </MuiThemeProvider>
            </>
        </SnackbarProvider>
    );
}

export default App;
